import { MenuItem } from "@mui/material";
import React, { FC } from "react";
import ViewEditSelect, { ViewEditSelectProps } from "../view-edit-select";
import { AgencyCode } from "../../../reducers/states/agency";
import { UserAgencies } from "../../../reducers/states/agency/agencies";

interface ViewEditSelectAgencyProps {
  props: Omit<ViewEditSelectProps["props"], "id" | "label"> & {
    id?: string;
    label?: string;
    supportOther?: boolean;
  };
}

const ViewEditSelectAgency: FC<ViewEditSelectAgencyProps> = ({ props }) => {
  return (
    <ViewEditSelect props={{
      ...props,
      id: props.id ?? "agencyId",
      label: props.label ?? "Agency",
    }}>
      <MenuItem value={AgencyCode.NOT_SELECTED}>(None)</MenuItem>
      {UserAgencies
        .map((agency) => (
          <MenuItem key={agency.id} value={agency.id}>
            {`${agency.name} - (${agency.id})`}
          </MenuItem>
        ))}
      { props.supportOther && (
        <MenuItem value={AgencyCode.OTHER}>{AgencyCode.OTHER}</MenuItem>        
      )}
      { props.supportOther && !(Object.values(AgencyCode).includes(props.value as AgencyCode)) && (
          <MenuItem value={props.value}>{props.value}</MenuItem>
        )}
    </ViewEditSelect>
  ); 
}

export default ViewEditSelectAgency